import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SavingsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"savings"}/>
}
